import { render, staticRenderFns } from "./UploadInvoice.vue?vue&type=template&id=74d49146&scoped=true"
import script from "./UploadInvoice.vue?vue&type=script&lang=js"
export * from "./UploadInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d49146",
  null
  
)

export default component.exports